import { fields, createSchema, validate as _validate } from '..';

const { arrayOfEmails } = fields;

const schema = createSchema({
  arrayOfAddresses: arrayOfEmails,
});

const validate = (data) => _validate(schema, data);

export default validate;
